module.exports = __webpack_public_path__ + "abkhazia.svg?028f0e726378edf163194b37072e3315";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/abkhazia.svg
// module id = 84
// module chunks = 10